import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import Radio from "designSystem/components/checkbox/Radio";
import { black, grey } from "designSystem/styles/color";
import React from "react";
import * as api from "../api";
import HashIcon from "../icon/HashIcon";

const PREFIX = "ChannelInfo";

const classes = {
	root: `${PREFIX}root`,
	selected: `${PREFIX}selected`,
	name: `${PREFIX}name`,
	navIcon: `${PREFIX}navIcon`,
	privacyIcon: `${PREFIX}privacyIcon`,
	checkBox: `${PREFIX}checkBox`,
};

const StyledGrid = styled(Grid)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		alignItems: "center",
		boxSizing: "border-box",
		cursor: "pointer",
		paddingBottom: theme.spacing(2),
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		paddingTop: theme.spacing(2),
		width: "100%",
		"&:hover": {
			backgroundColor: grey[200],
		},
		"&:active": {
			backgroundColor: theme.palette.HighlightSelected,
		},
		"&$selected": {
			backgroundColor: theme.palette.HighlightSelected,
		},
	},

	[`&.${classes.selected}`]: {},

	[`& .${classes.name}`]: {
		color: black[100],
		flex: 1,
		fontSize: "12px",
		height: "16px",
		minWidth: 0,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		width: "100%",
	},

	[`& .${classes.navIcon}`]: {
		height: "20px",
		marginLeft: theme.spacing(2),
		padding: "2px",
		width: "20px",
	},

	[`& .${classes.privacyIcon}`]: {
		color: black[100],
		height: "16px",
		marginRight: theme.spacing(1),
		width: "16px",
	},

	[`& .${classes.checkBox}`]: {
		height: "16px",
		marginRight: theme.spacing(1),
		width: "16px",
	},
}));

interface Props {
	channel: api.Conversation;
	selected?: boolean;
	onSelect?: () => void;
	onNavigate?: () => void;
}

const ChannelInfo: React.FunctionComponent<Props> = ({ channel, selected, onSelect, onNavigate }) => {
	const onClick = onNavigate ?? onSelect ?? (() => null);
	return (
		<StyledGrid
			className={`${classes.root} ${selected ? classes.selected : ""}`}
			container
			direction="row"
			onClick={(e) => { e.preventDefault(); onClick(); }}
		>
			{onSelect
				? <Grid className={classes.checkBox} item><Radio checked={selected} onClick={(e) => { e.preventDefault(); onSelect(); }} /></Grid>
				: null
			}
			<Grid className={classes.privacyIcon} item>{channel.private ? <LockIcon /> : <HashIcon />}</Grid>
			<Grid className={classes.name} item>{channel.name}</Grid>
			{onNavigate
				? <Grid className={classes.navIcon} item><ChevronRightIcon onClick={(e) => { e.preventDefault(); onNavigate(); }} /></Grid>
				: null
			}
		</StyledGrid>
	);
};

export default ChannelInfo;